//
import DashboardLayout from '@/layouts/DashboardLayout.vue';
import MinorAccountLinkProcess from './layouts/MinorAccountLinkProcess.vue';
import { RouteNames } from '@/router/routeNames';

export default {
  path: '/minor-account-link-process',
  component: DashboardLayout,
  children: [
    {
      path: '',
      name: RouteNames.MINOR_ACCOUNT_LINK_PROCESS,
      component: MinorAccountLinkProcess,
      meta: {
        pageTitle: 'Investements.MinorAccountLinkProcess',
      },
    },
  ],
};
